export const backgroundColors = {
  green: '#030500',
  amber: '#140f00',
  blue: '#000c17',
  red: '#0a0000',
  white: '#000',
  cyan: '#001f1f',
  orange: '#000',
};
